module.exports = __webpack_public_path__ + "static/media/529169a1.jpg";